import React from "react";
import Button from "components/common/Button";
import cx from "classnames";

interface ButtonBottomProps {
  label: string;
  onClick: () => void;
  className?: string;
}
export default function ButtonBottom(props: ButtonBottomProps) {
  return (
    <div
      className="flex justify-center items-center w-full px-4 py-3 bg-white"
      style={{ paddingBottom: 'calc(12px + env(safe-area-inset-bottom, 0px))' }}
    >
      <Button className={cx("w-full uppercase font-semibold text-base py-3", props.className)} {...props} />
    </div>
  );
}
